import type { FC } from 'react';

import { useTranslation } from '@eneco/i18n';
import { Text, TextLink } from '@eneco/sparky';
import { Usages_Reading_CounterModel } from '@monorepo-types/dc';

import { CounterInstructionDialog } from '../../CounterInstructionDialog/CounterInstructionDialog';
import { useMeterReadingsFlow } from '../../state/MeterReadingsFlow.machine';
import { METER_READING_STATES } from '../../state/MeterReadingsFlow.types';


export const CounterHint: FC<{
  productType: Lowercase<METER_READING_STATES['METER_READINGS']>;
  counter: Usages_Reading_CounterModel;
  denotation: string;
}> = ({ productType, counter, denotation }) => {
  const { t } = useTranslation();
  const { state } = useMeterReadingsFlow();

  const meter = state.context?.reading?.meters?.find((meter: { productType?: string }) => meter.productType === productType);
  const isDoubleMeter = !!meter?.counters && meter?.counters?.length > 1;
  const reading =
    meter?.counters?.find(({ counterIdentification }: { counterIdentification?: string | number }) => String(counter.counterIdentification) === String(counterIdentification))
      ?.value || 0;

  return (
    <Text whiteSpace={{ initial: 'pre-wrap', md: 'pre' }}>
      {t('lastReadingText', {
        reading,
        denotation,
      })}{' '}
      <CounterInstructionDialog
        productType={productType}
        isSmart={!!meter?.isSmart}
        counter={counter}
        isDoubleMeter={isDoubleMeter}
        reading={reading}
        meterNumber={meter?.meterNumber}
        trigger={<TextLink>{t('triggerLabel')}</TextLink>}
      />
    </Text>
  );
};
